module.exports = __webpack_public_path__ + "static/media/uoa-18.43d5c594.jpg";